import { Layout, PageHero } from "../components/Layout";
import { Seo } from "../components/Seo";
import { IndustriesGrid, CTA } from "../components/Sections";

export default function Industries() {
  return (
    <Layout>
      <Seo title="Industries We Serve" description="Neuravolt delivers domain-aware AI and software solutions across healthcare, finance, retail, manufacturing, logistics, education, and more." keywords="healthcare software, fintech development, retail technology, manufacturing software India, logistics tech solutions, education technology, Neuravolt industries" path="/industries" />
      <PageHero eyebrow="Industries" title="Domain expertise that ships" sub="We bring context-aware engineering to regulated, high-stakes environments." />
      <IndustriesGrid />
      <CTA />
    </Layout>
  );
}
